export default __webpack_public_path__ + "media/zurb/img/legacy/plunk/about-4-plus-c1291dcdf51e5c36b82966c071c8cdc2.jpg";